// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2XOGs","insightsList":"newBusinessInsightsMenu_insightsList__1XpTS","active":"newBusinessInsightsMenu_active__2qA9h"};